function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.97949 12.4645H3.97949V6.46448",
  stroke: "#D93025",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7785 8.22183C22.757 7.20038 21.5444 6.39013 20.2098 5.83733C18.8752 5.28452 17.4448 5 16.0003 5C14.5558 5 13.1254 5.28452 11.7908 5.83733C10.4562 6.39013 9.24358 7.20038 8.22213 8.22183L3.97949 12.4645",
  stroke: "#D93025",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.0205 19.5355H28.0205V25.5355",
  stroke: "#D93025",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.22168 23.7782C9.24312 24.7996 10.4558 25.6099 11.7903 26.1627C13.1249 26.7155 14.5553 27 15.9999 27C17.4444 27 18.8748 26.7155 20.2094 26.1627C21.544 25.6099 22.7566 24.7996 23.778 23.7782L28.0207 19.5355",
  stroke: "#D93025",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgArrowsCounterClockwise = function SvgArrowsCounterClockwise(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowsCounterClockwise, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrows-counter-clockwise.91a40029.svg";
export { ForwardRef as ReactComponent };